import { render, staticRenderFns } from "./ViewBackOrders.vue?vue&type=template&id=2db3352b&scoped=true"
import script from "./ViewBackOrders.vue?vue&type=script&lang=js"
export * from "./ViewBackOrders.vue?vue&type=script&lang=js"
import style0 from "./ViewBackOrders.vue?vue&type=style&index=0&id=2db3352b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3352b",
  null
  
)

export default component.exports